import _extends from "@babel/runtime/helpers/esm/extends";
/** @jsx jsx */

import { jsx } from 'theme-ui';
import React from 'react';
import { useConfig } from 'docz';
import { LiveProvider, LiveError, LivePreview, LiveEditor } from 'react-live';
import { Resizable } from 're-resizable';
import copy from 'copy-text-to-clipboard';
import { Wrapper } from './Wrapper';
import { usePrismTheme } from '~utils/theme';
import * as styles from './styles';
import * as Icons from '../Icons';
import { jsx as ___EmotionJSX } from "@emotion/core";

var getResizableProps = function getResizableProps(width, setWidth) {
  return {
    minWidth: 260,
    maxWidth: '100%',
    size: {
      width: width,
      height: 'auto'
    },
    style: {
      margin: 0,
      marginRight: 'auto'
    },
    enable: {
      top: false,
      right: true,
      bottom: false,
      left: false,
      topRight: false,
      bottomRight: false,
      bottomLeft: false,
      topLeft: false
    },
    onResizeStop: function onResizeStop(e, direction, ref) {
      setWidth(ref.style.width);
    }
  };
};

var transformCode = function transformCode(code) {
  if (code.startsWith('()') || code.startsWith('class')) return code;
  return "<React.Fragment>" + code + "</React.Fragment>";
};

export var Playground = function Playground(_ref) {
  var code = _ref.code,
      scope = _ref.scope,
      language = _ref.language,
      _ref$useScoping = _ref.useScoping,
      useScoping = _ref$useScoping === void 0 ? false : _ref$useScoping;

  var _useConfig = useConfig(),
      _useConfig$themeConfi = _useConfig.themeConfig,
      showPlaygroundEditor = _useConfig$themeConfi.showPlaygroundEditor,
      showLiveError = _useConfig$themeConfi.showLiveError,
      showLivePreview = _useConfig$themeConfi.showLivePreview; // Makes sure scope is only given on mount to avoid infinite re-render on hot reloads


  var _React$useState = React.useState(scope),
      scopeOnMount = _React$useState[0];

  var theme = usePrismTheme();

  var _React$useState2 = React.useState(showPlaygroundEditor),
      showingCode = _React$useState2[0],
      setShowingCode = _React$useState2[1];

  var _React$useState3 = React.useState('100%'),
      width = _React$useState3[0],
      setWidth = _React$useState3[1];

  var resizableProps = getResizableProps(width, setWidth);

  var copyCode = function copyCode() {
    return copy(code);
  };

  var toggleCode = function toggleCode() {
    return setShowingCode(function (s) {
      return !s;
    });
  };

  return jsx(Resizable, _extends({}, resizableProps, {
    "data-testid": "playground"
  }), jsx(LiveProvider, {
    code: code,
    scope: scopeOnMount,
    transformCode: transformCode,
    language: language,
    theme: theme
  }, jsx("div", {
    sx: styles.previewWrapper
  }, jsx(Wrapper, {
    content: "preview",
    useScoping: useScoping,
    showingCode: showingCode
  }, showLivePreview && jsx(LivePreview, {
    sx: styles.preview,
    "data-testid": "live-preview"
  })), jsx("div", {
    sx: styles.buttons
  }, jsx("button", {
    sx: styles.button,
    onClick: copyCode
  }, jsx(Icons.Clipboard, {
    size: 12
  })), jsx("button", {
    sx: styles.button,
    onClick: toggleCode
  }, jsx(Icons.Code, {
    size: 12
  })))), showingCode && jsx(Wrapper, {
    content: "editor",
    useScoping: useScoping,
    showingCode: showingCode
  }, jsx("div", {
    sx: styles.editor(theme)
  }, jsx(LiveEditor, {
    "data-testid": "live-editor"
  }))), showLiveError && jsx(LiveError, {
    sx: styles.error,
    "data-testid": "live-error"
  })));
};

if (typeof Playground !== 'undefined' && Playground && Playground === Object(Playground) && Object.isExtensible(Playground) && !Playground.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Playground, '__filemeta', {
    configurable: true,
    value: {
      name: "Playground",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/index.js"
    }
  });
}